import FiltersService from './FiltersService'

export default FiltersService
